<!--
 * @Author: taosong
 * @Date: 2021-03-03 15:24:55
 * @LastEditors: taosong
 * @LastEditTime: 2021-06-29 17:13:58
 * @Description: taosongs
-->
<template>
  <div class="title">
    <span class="line"></span>
    <span class="font">{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "AnswerDetailLine",
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>
<style lang="scss" scoped>
@import "scss/color.scss";
.title {
  display: flex;
  align-items: center;
  .line {
    width: 9px;
    height: 28px;
    background-color: var(--primary-color);
    border-radius: 8px;
  }
  .font {
    font-size: 32px;
    color: #333;
    margin-left: 15px;
    font-weight: bold;
  }
}
</style>
